import { buscarPreferenciasDoUsuario, gravarPreferenciaDoUsuario } from '@/api/preferenciasDoUsuario'
import { EscolhaDeVersao, escolhaAoTrocar, lerEscolhaDeVersao, passouDaVirada, VersaoDaTela, versaoQueAbre } from './versao-da-tela'

export type TelaDeLoja = VersaoDaTela

const CHAVE = 'tela-de-loja'

/** Até 30/11/2026 a loja abre na tela antiga para quem não escolheu; a partir de 01/12, na nova para todos. */
export const VIRADA_DA_TELA_DE_LOJA = new Date(2026, 11, 1)

// undefined: ainda não perguntou ao servidor nesta sessão; null: o usuário ainda não escolheu.
// O logout recarrega a página, então o cache não passa de um usuário para outro.
let escolhida: EscolhaDeVersao | null | undefined

/** O que o usuário gravou para a edição de loja, ou null se ainda não escolheu (ou se a consulta falhar). */
export async function buscarEscolhaDaTelaDeLoja(): Promise<EscolhaDeVersao | null> {
	if (escolhida !== undefined) return escolhida
	try {
		const preferencias = await buscarPreferenciasDoUsuario()
		escolhida = lerEscolhaDeVersao(preferencias ? preferencias[CHAVE] : undefined)
	} catch (error) {
		// Sem a preferência a loja abre na tela padrão do dia; não vale travar a tela por isso
		return null
	}
	return escolhida
}

export const passouDaViradaDaTelaDeLoja = (agora = new Date()) => passouDaVirada(VIRADA_DA_TELA_DE_LOJA, agora)

export const telaDeLojaQueAbre = (escolha: EscolhaDeVersao | null, agora = new Date()): TelaDeLoja =>
	versaoQueAbre(escolha, VIRADA_DA_TELA_DE_LOJA, agora)

export async function gravarTelaDeLojaEscolhida(tela: TelaDeLoja, agora = new Date()): Promise<EscolhaDeVersao> {
	const escolha = escolhaAoTrocar(tela, VIRADA_DA_TELA_DE_LOJA, agora)
	await gravarPreferenciaDoUsuario(CHAVE, escolha)
	escolhida = escolha
	return escolha
}
